import { CONFIG_SERVICE_KEYS } from '@web-platform/shared-universal-constants-config';
import { getConfigServiceValue } from '@web-platform/shared-universal-utils-frontend/src/config';

import type { PersonalItemAssessmentOutcome } from './sonarV3PricingOptionFareMapper';
import type { SkyscannerSonarV3Response } from '@skyscanner-internal/sonar-web-http-client';

type Itinerary = { legs?: SkyscannerSonarV3Response.Leg[] };

const getCarrierIds = (legs: SkyscannerSonarV3Response.Leg[] = []): number[] =>
  (legs ?? [])
    .flatMap((leg) => leg.segments ?? [])
    .map((segment) => segment.operatingCarrier?.id)
    .filter((id): id is number => id !== undefined);

const getNotIncludedCarrierIds = (): Set<string> => {
  const rawCarrierIds = getConfigServiceValue(
    CONFIG_SERVICE_KEYS.OPS.PERSONAL_ITEM_NOT_INCLUDED_CARRIER_IDS,
  );

  return new Set(
    (typeof rawCarrierIds === 'string' ? rawCarrierIds : '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean),
  );
};

export const getPersonalItemOutcome = (itinerary: Itinerary): PersonalItemAssessmentOutcome => {
  const notIncludedCarrierIds = getNotIncludedCarrierIds();

  return getCarrierIds(itinerary.legs).some((id) => notIncludedCarrierIds.has(String(id)))
    ? 'UNKNOWN'
    : 'INCLUDED';
};
